// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"f1b4126e","70":"9f3cace5","355":"bb192200","453":"80f9b661","538":"3a6900e6","580":"5c405a2a","842":"b206a922","889":"23e7a7cf","921":"e664fb43","935":"81a708a7","995":"c0ce1eea"}[chunkId] + ".chunk.js";
};